import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferTidalToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.transferTidalToTidal}
            sections={<PairTransferGuideContent sourceKey="tidal" destKey="tidal" />}
        />
    );
}
